module.exports = __webpack_public_path__ + "static/media/who_we_are.8820b0ac.svg";